import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { getContentByType } from '@glowforge/gf-styled/src/models/page';
import Image from '@glowforge/gf-styled/src/components/contentful-views/image';
import CookieNavigationItem from './cookie-navigation-item';

import {
  CountryLink,
  ListWrapper,
  NavigationWrapper,
} from './legal-markdown.styles';

const CountryNavigation = ({ countries, cookieLinkText }) => {
  const { pathname, asPath } = useRouter();
  let currentPath = asPath.substr(0, asPath.indexOf('?'));
  currentPath = currentPath || asPath;

  const basePath = pathname.split('/')[1];

  const countryLinks = countries?.map((country) => {
    const button = getContentByType(country?.fields?.listItems, 'buttonLink');
    const icon = getContentByType(country?.fields?.listItems, 'mediaObject');

    return {
      id: country?.fields?.id,
      icon: icon[0]?.fields,
      text: button[0]?.fields?.text,
      url: `/${basePath}${button[0]?.fields?.url || ''}`,
    };
  });

  return (
    <NavigationWrapper aria-label='Country Navigation' role='navigation'>
      <ListWrapper>
        {countryLinks.map((link) => (
          <li key={link?.url}>
            <Link href={link?.url} passHref legacyBehavior>
              <CountryLink variant='nav' $isActive={currentPath === link?.url}>
                <Image media={link?.icon?.media} />
                {link?.text}
              </CountryLink>
            </Link>
          </li>
        ))}
        <li>
          {cookieLinkText ? (
            <CookieNavigationItem href='/cookie-policy' text={cookieLinkText} />
          ) : null}
        </li>
      </ListWrapper>
    </NavigationWrapper>
  );
};

CountryNavigation.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.shape({})),
  cookieLinkText: PropTypes.string,
};

CountryNavigation.defaultProps = {
  countries: [],
  cookieLinkText: null,
};

export default CountryNavigation;
